export default "__VITE_ASSET__UfehybFg__"